import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_PIPELINES_ACTION_TYPE } from '../actions';

const initialState = {};

const loanPipelinesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_PIPELINES_ACTION_TYPE.GET_LOAN_PIPELINES:
        return payload || initialState;

      case LOAN_PIPELINES_ACTION_TYPE.CREATE_LOAN_PIPELINE:
        draft[payload.id] = payload;
        break;

      case LOAN_PIPELINES_ACTION_TYPE.EDIT_LOAN_PIPELINE: {
        if (!draft[payload.id]) {
          return state;
        }

        draft[payload.id] = { ...draft[payload.id], ...payload };
        break;
      }

      case LOAN_PIPELINES_ACTION_TYPE.DELETE_LOAN_PIPELINE:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanPipelinesReducer;
